import {
	brandPrimary,
	brandPrimarySurface,
	brandPrimarySurfaceBorder,
	brandPrimarySurfaceHover,
	textColor,
} from "./tokens";
import { CSS_VAR_AUTH } from "./auth";
import { getShellCssVariables } from "./css-variables";

/** Apply shell + app theme CSS variables to `:root`. */
export function applyShellCssVariables(): void {
	const root = document.documentElement;
	const variables = {
		...getShellCssVariables(),
		[CSS_VAR_AUTH.textColor]: textColor,
		[CSS_VAR_AUTH.brandPrimary]: brandPrimary,
		"--psda-primary-surface": brandPrimarySurface,
		"--psda-primary-surface-hover": brandPrimarySurfaceHover,
		"--psda-primary-surface-border": brandPrimarySurfaceBorder,
	};

	for (const [name, value] of Object.entries(variables)) {
		root.style.setProperty(name, value);
	}
}

/** Call before React render so sidebar colors are correct on first paint. */
export function bootstrapShellTheme(): void {
	applyShellCssVariables();
}
